import React from 'react';

const Transaction = ({ transaction, index, isMobile }) => {
  return (
    <div className="card">
      {/* <a href={transaction.downloadURL}> */}
        <div className="card-header px-0" id={'transaction-' + index}>
          <div className="d-flex mx-0 transaction">
            {/* Date */}
            <div
              style={{ flex: 3 }}
              data-toggle={isMobile ? 'tooltip' : ''}
              data-original-title={transaction.date.toLocaleDateString()}
              title={transaction.date.toLocaleDateString()}
            >
              <p className="date">{transaction.date.toLocaleDateString()}</p>
            </div>
            {/* Number */}
            <div
              style={{ flex: 4 }}
              data-toggle={isMobile ? 'tooltip' : ''}
              data-original-title={transaction.number}
              title={transaction.number}
            >
              <p className="number">{transaction.number}</p>
            </div>
            {/* Amount */}
            <div
              style={{ flex: 3 }}
              data-toggle={isMobile ? 'tooltip' : ''}
              data-original-title={transaction.amount}
              title={transaction.amount}
            >
              <p className="amount">{transaction.currency} ${transaction.amount}</p>
            </div>
            {/* Status */}
            <div
              style={{ flex: 3 }}
              data-toggle={isMobile ? 'tooltip' : ''}
              data-original-title={transaction.status}
              title={transaction.status}
            >
              <p className={`status font-weight-bold${transaction.status === 'Paid' ? ' text-success' : ''}`}>{transaction.status}</p>
            </div>
          </div>
        </div>
      {/* </a> */}
    </div>
  );
};

export default Transaction;
